module.exports = (parcelRequire.load("5XMrN")).then(() => parcelRequire('lxIzd'));